import React, { useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";

import axios from "axios";
import AdminNav from "./AdminNav";
import config from "../../../function/config";
import Footer from "../../Footer";
import { formatDistanceToNow } from "date-fns";
import { toast } from "react-toastify";
import NewAdminNav from "./NewAdminNav";
import NewFooter from "../../NewFooter";


export default function AdminLogistics() {
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [ports, setPorts] = useState([]);
  const [count,setCount] = useState(0)

 const [allShips, setallShips] = useState([]);
   const [allShipsReg, setallShipsReg] = useState([]);
  const [filteredShips, setFilteredShips] = useState([]);
  const [selectedView, setSelectedView] = useState("ship"); // "ship" or "cargo"
  const [refPage, setRefPage] = useState(1);


  const navigate = useNavigate();

  const regions = {
    Asia: [
      {
        value: "Afghanistan",
        label: "Afghanistan",
        flag: "https://flagcdn.com/w320/af.png",
      },
      {
        value: "Armenia",
        label: "Armenia",
        flag: "https://flagcdn.com/w320/am.png",
      },
      {
        value: "Azerbaijan",
        label: "Azerbaijan",
        flag: "https://flagcdn.com/w320/az.png",
      },
      {
        value: "Bahrain",
        label: "Bahrain",
        flag: "https://flagcdn.com/w320/bh.png",
      },
      {
        value: "Bangladesh",
        label: "Bangladesh",
        flag: "https://flagcdn.com/w320/bd.png",
      },
      {
        value: "Brunei",
        label: "Brunei",
        flag: "https://flagcdn.com/w320/bn.png",
      },
      {
        value: "Cambodia",
        label: "Cambodia",
        flag: "https://flagcdn.com/w320/kh.png",
      },
      {
        value: "China",
        label: "China",
        flag: "https://flagcdn.com/w320/cn.png",
      },
      {
        value: "Cyprus",
        label: "Cyprus",
        flag: "https://flagcdn.com/w320/cy.png",
      },
      {
        value: "Georgia",
        label: "Georgia",
        flag: "https://flagcdn.com/w320/ge.png",
      },
      {
        value: "India",
        label: "India",
        flag: "https://flagcdn.com/w320/in.png",
      },
      {
        value: "Indonesia",
        label: "Indonesia",
        flag: "https://flagcdn.com/w320/id.png",
      },
      { value: "Iran", label: "Iran", flag: "https://flagcdn.com/w320/ir.png" },
      { value: "Iraq", label: "Iraq", flag: "https://flagcdn.com/w320/iq.png" },
      {
        value: "Israel",
        label: "Israel",
        flag: "https://flagcdn.com/w320/il.png",
      },
      {
        value: "Japan",
        label: "Japan",
        flag: "https://flagcdn.com/w320/jp.png",
      },
      {
        value: "Jordan",
        label: "Jordan",
        flag: "https://flagcdn.com/w320/jo.png",
      },
      {
        value: "Kazakhstan",
        label: "Kazakhstan",
        flag: "https://flagcdn.com/w320/kz.png",
      },
      {
        value: "Kuwait",
        label: "Kuwait",
        flag: "https://flagcdn.com/w320/kw.png",
      },
      {
        value: "Kyrgyzstan",
        label: "Kyrgyzstan",
        flag: "https://flagcdn.com/w320/kg.png",
      },
      { value: "Laos", label: "Laos", flag: "https://flagcdn.com/w320/la.png" },
      {
        value: "Lebanon",
        label: "Lebanon",
        flag: "https://flagcdn.com/w320/lb.png",
      },
      {
        value: "Malaysia",
        label: "Malaysia",
        flag: "https://flagcdn.com/w320/my.png",
      },
      {
        value: "Maldives",
        label: "Maldives",
        flag: "https://flagcdn.com/w320/mv.png",
      },
      {
        value: "Mongolia",
        label: "Mongolia",
        flag: "https://flagcdn.com/w320/mn.png",
      },
      {
        value: "Myanmar",
        label: "Myanmar",
        flag: "https://flagcdn.com/w320/mm.png",
      },
      {
        value: "Nepal",
        label: "Nepal",
        flag: "https://flagcdn.com/w320/np.png",
      },
      {
        value: "North Korea",
        label: "North Korea",
        flag: "https://flagcdn.com/w320/kp.png",
      },
      { value: "Oman", label: "Oman", flag: "https://flagcdn.com/w320/om.png" },
      {
        value: "Pakistan",
        label: "Pakistan",
        flag: "https://flagcdn.com/w320/pk.png",
      },
      {
        value: "Palestine",
        label: "Palestine",
        flag: "https://flagcdn.com/w320/ps.png",
      },
      {
        value: "Philippines",
        label: "Philippines",
        flag: "https://flagcdn.com/w320/ph.png",
      },
      {
        value: "Qatar",
        label: "Qatar",
        flag: "https://flagcdn.com/w320/qa.png",
      },
      {
        value: "Russia",
        label: "Russia",
        flag: "https://flagcdn.com/w320/ru.png",
      },
      {
        value: "Saudi Arabia",
        label: "Saudi Arabia",
        flag: "https://flagcdn.com/w320/sa.png",
      },
      {
        value: "Singapore",
        label: "Singapore",
        flag: "https://flagcdn.com/w320/sg.png",
      },
      {
        value: "Korea",
        label: "Korea",
        flag: "https://flagcdn.com/w320/kr.png",
      },
      {
        value: "Sri Lanka",
        label: "Sri Lanka",
        flag: "https://flagcdn.com/w320/lk.png",
      },
      {
        value: "Syria",
        label: "Syria",
        flag: "https://flagcdn.com/w320/sy.png",
      },
      {
        value: "Taiwan",
        label: "Taiwan",
        flag: "https://flagcdn.com/w320/tw.png",
      },
      {
        value: "Tajikistan",
        label: "Tajikistan",
        flag: "https://flagcdn.com/w320/tj.png",
      },
      {
        value: "Thailand",
        label: "Thailand",
        flag: "https://flagcdn.com/w320/th.png",
      },
      {
        value: "Timor-Leste",
        label: "Timor-Leste",
        flag: "https://flagcdn.com/w320/tl.png",
      },
      {
        value: "Turkey",
        label: "Turkey",
        flag: "https://flagcdn.com/w320/tr.png",
      },
      {
        value: "Turkmenistan",
        label: "Turkmenistan",
        flag: "https://flagcdn.com/w320/tm.png",
      },
      
      {
        value: "United Arab Emirates",
        label: "United Arab Emirates",
        flag: "https://flagcdn.com/w320/ae.png",
      },
      {
        value: "Uzbekistan",
        label: "Uzbekistan",
        flag: "https://flagcdn.com/w320/uz.png",
      },
      
      {
        value: "Vietnam",
        label: "Vietnam",
        flag: "https://flagcdn.com/w320/vn.png",
      },
      {
        value: "Yemen",
        label: "Yemen",
        flag: "https://flagcdn.com/w320/ye.png",
      },
      
    ],

    Africa: [
      {
        value: "Algeria",
        label: "Algeria",
        flag: "https://flagcdn.com/w320/dz.png",
      },
      {
        value: "Angola",
        label: "Angola",
        flag: "https://flagcdn.com/w320/ao.png",
      },
      {
        value: "Benin",
        label: "Benin",
        flag: "https://flagcdn.com/w320/bj.png",
      },
      {
        value: "Botswana",
        label: "Botswana",
        flag: "https://flagcdn.com/w320/bw.png",
      },
      {
        value: "Burkina Faso",
        label: "Burkina Faso",
        flag: "https://flagcdn.com/w320/bf.png",
      },
      {
        value: "Burundi",
        label: "Burundi",
        flag: "https://flagcdn.com/w320/bi.png",
      },
      {
        value: "Cape Verde",
        label: "Cape Verde",
        flag: "https://flagcdn.com/w320/cv.png",
      },
      {
        value: "Cameroon",
        label: "Cameroon",
        flag: "https://flagcdn.com/w320/cm.png",
      },
      {
        value: "Central African Republic",
        label: "Central African Republic",
        flag: "https://flagcdn.com/w320/cf.png",
      },
      { value: "Chad", label: "Chad", flag: "https://flagcdn.com/w320/td.png" },
      {
        value: "Comoros",
        label: "Comoros",
        flag: "https://flagcdn.com/w320/km.png",
      },
      {
        value: "Congo, Democratic Republic of the",
        label: "Congo, Democratic Republic of the",
        flag: "https://flagcdn.com/w320/cd.png",
      },
      {
        value: "Congo, Republic of the",
        label: "Congo, Republic of the",
        flag: "https://flagcdn.com/w320/cg.png",
      },
      {
        value: "Ivory Coast",
        label: "Ivory Coast",
        flag: "https://flagcdn.com/w320/ci.png",
      },
      {
        value: "Djibouti",
        label: "Djibouti",
        flag: "https://flagcdn.com/w320/dj.png",
      },
      {
        value: "Egypt",
        label: "Egypt",
        flag: "https://flagcdn.com/w320/eg.png",
      },
      {
        value: "Equatorial Guinea",
        label: "Equatorial Guinea",
        flag: "https://flagcdn.com/w320/gq.png",
      },
      {
        value: "Eritrea",
        label: "Eritrea",
        flag: "https://flagcdn.com/w320/er.png",
      },
      {
        value: "Ethiopia",
        label: "Ethiopia",
        flag: "https://flagcdn.com/w320/et.png",
      },
      {
        value: "Gabon",
        label: "Gabon",
        flag: "https://flagcdn.com/w320/ga.png",
      },
      {
        value: "Gambia",
        label: "Gambia",
        flag: "https://flagcdn.com/w320/gm.png",
      },
      {
        value: "Ghana",
        label: "Ghana",
        flag: "https://flagcdn.com/w320/gh.png",
      },
      {
        value: "Guinea",
        label: "Guinea",
        flag: "https://flagcdn.com/w320/gn.png",
      },
      {
        value: "Guinea-Bissau",
        label: "Guinea-Bissau",
        flag: "https://flagcdn.com/w320/gw.png",
      },
      {
        value: "Kenya",
        label: "Kenya",
        flag: "https://flagcdn.com/w320/ke.png",
      },
      {
        value: "Lesotho",
        label: "Lesotho",
        flag: "https://flagcdn.com/w320/ls.png",
      },
      {
        value: "Liberia",
        label: "Liberia",
        flag: "https://flagcdn.com/w320/lr.png",
      },
      {
        value: "Libya",
        label: "Libya",
        flag: "https://flagcdn.com/w320/ly.png",
      },
      {
        value: "Madagascar",
        label: "Madagascar",
        flag: "https://flagcdn.com/w320/mg.png",
      },
      {
        value: "Malawi",
        label: "Malawi",
        flag: "https://flagcdn.com/w320/mw.png",
      },
      { value: "Mali", label: "Mali", flag: "https://flagcdn.com/w320/ml.png" },
      {
        value: "Mauritania",
        label: "Mauritania",
        flag: "https://flagcdn.com/w320/mr.png",
      },
      {
        value: "Mauritius",
        label: "Mauritius",
        flag: "https://flagcdn.com/w320/mu.png",
      },
      {
        value: "Morocco",
        label: "Morocco",
        flag: "https://flagcdn.com/w320/ma.png",
      },
      {
        value: "Mozambique",
        label: "Mozambique",
        flag: "https://flagcdn.com/w320/mz.png",
      },
      {
        value: "Namibia",
        label: "Namibia",
        flag: "https://flagcdn.com/w320/na.png",
      },
      {
        value: "Niger",
        label: "Niger",
        flag: "https://flagcdn.com/w320/ne.png",
      },
      {
        value: "Nigeria",
        label: "Nigeria",
        flag: "https://flagcdn.com/w320/ng.png",
      },
      {
        value: "Rwanda",
        label: "Rwanda",
        flag: "https://flagcdn.com/w320/rw.png",
      },
      {
        value: "Sao Tome and Principe",
        label: "Sao Tome and Principe",
        flag: "https://flagcdn.com/w320/st.png",
      },
      {
        value: "Senegal",
        label: "Senegal",
        flag: "https://flagcdn.com/w320/sn.png",
      },
      {
        value: "Seychelles",
        label: "Seychelles",
        flag: "https://flagcdn.com/w320/sc.png",
      },
      {
        value: "Sierra Leone",
        label: "Sierra Leone",
        flag: "https://flagcdn.com/w320/sl.png",
      },
      {
        value: "Somalia",
        label: "Somalia",
        flag: "https://flagcdn.com/w320/so.png",
      },
      {
        value: "South Africa",
        label: "South Africa",
        flag: "https://flagcdn.com/w320/za.png",
      },
      {
        value: "Sudan",
        label: "Sudan",
        flag: "https://flagcdn.com/w320/sd.png",
      },
      {
        value: "Tanzania",
        label: "Tanzania",
        flag: "https://flagcdn.com/w320/tz.png",
      },
      { value: "Togo", label: "Togo", flag: "https://flagcdn.com/w320/tg.png" },
      {
        value: "Tunisia",
        label: "Tunisia",
        flag: "https://flagcdn.com/w320/tn.png",
      },
      {
        value: "Uganda",
        label: "Uganda",
        flag: "https://flagcdn.com/w320/ug.png",
      },
      {
        value: "Zambia",
        label: "Zambia",
        flag: "https://flagcdn.com/w320/zm.png",
      },
      {
        value: "Zimbabwe",
        label: "Zimbabwe",
        flag: "https://flagcdn.com/w320/zw.png",
      },
    ],
    Europe: [
      {
        value: "Albania",
        label: "Albania",
        flag: "https://flagcdn.com/w320/al.png",
      },
      {
        value: "Andorra",
        label: "Andorra",
        flag: "https://flagcdn.com/w320/ad.png",
      },
      {
        value: "Armenia",
        label: "Armenia",
        flag: "https://flagcdn.com/w320/am.png",
      },
      {
        value: "Austria",
        label: "Austria",
        flag: "https://flagcdn.com/w320/at.png",
      },
      {
        value: "Azerbaijan",
        label: "Azerbaijan",
        flag: "https://flagcdn.com/w320/az.png",
      },
      {
        value: "Belarus",
        label: "Belarus",
        flag: "https://flagcdn.com/w320/by.png",
      },
      {
        value: "Belgium",
        label: "Belgium",
        flag: "https://flagcdn.com/w320/be.png",
      },
      {
        value: "Bosnia and Herzegovina",
        label: "Bosnia and Herzegovina",
        flag: "https://flagcdn.com/w320/ba.png",
      },
      {
        value: "Bulgaria",
        label: "Bulgaria",
        flag: "https://flagcdn.com/w320/bg.png",
      },
      {
        value: "Croatia",
        label: "Croatia",
        flag: "https://flagcdn.com/w320/hr.png",
      },
      {
        value: "Cyprus",
        label: "Cyprus",
        flag: "https://flagcdn.com/w320/cy.png",
      },
      {
        value: "Czech Republic",
        label: "Czech Republic",
        flag: "https://flagcdn.com/w320/cz.png",
      },
      {
        value: "Denmark",
        label: "Denmark",
        flag: "https://flagcdn.com/w320/dk.png",
      },
      {
        value: "Estonia",
        label: "Estonia",
        flag: "https://flagcdn.com/w320/ee.png",
      },
      {
        value: "Finland",
        label: "Finland",
        flag: "https://flagcdn.com/w320/fi.png",
      },
      {
        value: "France",
        label: "France",
        flag: "https://flagcdn.com/w320/fr.png",
      },
      {
        value: "Georgia",
        label: "Georgia",
        flag: "https://flagcdn.com/w320/ge.png",
      },
      {
        value: "Germany",
        label: "Germany",
        flag: "https://flagcdn.com/w320/de.png",
      },
      {
        value: "Greece",
        label: "Greece",
        flag: "https://flagcdn.com/w320/gr.png",
      },
      {
        value: "Hungary",
        label: "Hungary",
        flag: "https://flagcdn.com/w320/hu.png",
      },
      {
        value: "Iceland",
        label: "Iceland",
        flag: "https://flagcdn.com/w320/is.png",
      },
      {
        value: "Ireland",
        label: "Ireland",
        flag: "https://flagcdn.com/w320/ie.png",
      },
      {
        value: "Italy",
        label: "Italy",
        flag: "https://flagcdn.com/w320/it.png",
      },
      {
        value: "Kazakhstan",
        label: "Kazakhstan",
        flag: "https://flagcdn.com/w320/kz.png",
      },
      {
        value: "Kosovo",
        label: "Kosovo",
        flag: "https://flagcdn.com/w320/xk.png",
      },
      {
        value: "Latvia",
        label: "Latvia",
        flag: "https://flagcdn.com/w320/lv.png",
      },
      {
        value: "Liechtenstein",
        label: "Liechtenstein",
        flag: "https://flagcdn.com/w320/li.png",
      },
      {
        value: "Lithuania",
        label: "Lithuania",
        flag: "https://flagcdn.com/w320/lt.png",
      },
      {
        value: "Luxembourg",
        label: "Luxembourg",
        flag: "https://flagcdn.com/w320/lu.png",
      },
      {
        value: "Malta",
        label: "Malta",
        flag: "https://flagcdn.com/w320/mt.png",
      },
      {
        value: "Moldova",
        label: "Moldova",
        flag: "https://flagcdn.com/w320/md.png",
      },
      {
        value: "Monaco",
        label: "Monaco",
        flag: "https://flagcdn.com/w320/mc.png",
      },
      {
        value: "Montenegro",
        label: "Montenegro",
        flag: "https://flagcdn.com/w320/me.png",
      },
      {
        value: "Netherlands",
        label: "Netherlands",
        flag: "https://flagcdn.com/w320/nl.png",
      },
      {
        value: "North Macedonia",
        label: "North Macedonia",
        flag: "https://flagcdn.com/w320/mk.png",
      },
      {
        value: "Norway",
        label: "Norway",
        flag: "https://flagcdn.com/w320/no.png",
      },
      {
        value: "Poland",
        label: "Poland",
        flag: "https://flagcdn.com/w320/pl.png",
      },
      {
        value: "Portugal",
        label: "Portugal",
        flag: "https://flagcdn.com/w320/pt.png",
      },
      {
        value: "Romania",
        label: "Romania",
        flag: "https://flagcdn.com/w320/ro.png",
      },
      {
        value: "Russia",
        label: "Russia",
        flag: "https://flagcdn.com/w320/ru.png",
      },
      {
        value: "San Marino",
        label: "San Marino",
        flag: "https://flagcdn.com/w320/sm.png",
      },
      {
        value: "Serbia",
        label: "Serbia",
        flag: "https://flagcdn.com/w320/rs.png",
      },
      {
        value: "Slovakia",
        label: "Slovakia",
        flag: "https://flagcdn.com/w320/sk.png",
      },
      {
        value: "Slovenia",
        label: "Slovenia",
        flag: "https://flagcdn.com/w320/si.png",
      },
      {
        value: "Spain",
        label: "Spain",
        flag: "https://flagcdn.com/w320/es.png",
      },
      {
        value: "Sweden",
        label: "Sweden",
        flag: "https://flagcdn.com/w320/se.png",
      },
      {
        value: "Switzerland",
        label: "Switzerland",
        flag: "https://flagcdn.com/w320/ch.png",
      },
      {
        value: "Turkey",
        label: "Turkey",
        flag: "https://flagcdn.com/w320/tr.png",
      },
      {
        value: "Ukraine",
        label: "Ukraine",
        flag: "https://flagcdn.com/w320/ua.png",
      },
      {
        value: "United Kingdom",
        label: "United Kingdom",
        flag: "https://flagcdn.com/w320/gb.png",
      },
      {
        value: "Vatican City",
        label: "Vatican City",
        flag: "https://flagcdn.com/w320/va.png",
      },
    ],
    America: [
      {
        value: "Antigua and Barbuda",
        label: "Antigua and Barbuda",
        flag: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Flag_of_Antigua_and_Barbuda.svg/1200px-Flag_of_Antigua_and_Barbuda.svg.png",
      },
      {
        value: "Argentina",
        label: "Argentina",
        flag: "https://flagcdn.com/w320/ar.png",
      },
      {
        value: "Aruba",
        label: "Aruba",
        flag: "https://flagcdn.com/w320/aw.png",
      },
      {
        value: "Bahamas",
        label: "Bahamas",
        flag: "https://flagcdn.com/w320/bs.png",
      },
      {
        value: "Barbados",
        label: "Barbados",
        flag: "https://flagcdn.com/w320/bb.png",
      },
      {
        value: "Belize",
        label: "Belize",
        flag: "https://flagcdn.com/w320/bz.png",
      },
      {
        value: "Bermuda",
        label: "Bermuda",
        flag: "https://flagcdn.com/w320/bm.png",
      },
      {
        value: "Bolivia",
        label: "Bolivia",
        flag: "https://flagcdn.com/w320/bo.png",
      },
      {
        value: "Brazil",
        label: "Brazil",
        flag: "https://flagcdn.com/w320/br.png",
      },
      {
        value: "British Virgin Islands",
        label: "British Virgin Islands",
        flag: "https://flagcdn.com/w320/vg.png",
      },
      {
        value: "Canada",
        label: "Canada",
        flag: "https://flagcdn.com/w320/ca.png",
      },
      {
        value: "Cayman Islands",
        label: "Cayman Islands",
        flag: "https://flagcdn.com/w320/ky.png",
      },
      {
        value: "Chile",
        label: "Chile",
        flag: "https://flagcdn.com/w320/cl.png",
      },
      {
        value: "Colombia",
        label: "Colombia",
        flag: "https://flagcdn.com/w320/co.png",
      },
      {
        value: "Costa Rica",
        label: "Costa Rica",
        flag: "https://flagcdn.com/w320/cr.png",
      },
      {
        value: "Cuba",
        label: "Cuba",
        flag: "https://flagcdn.com/w320/cu.png",
      },
      {
        value: "Curacao",
        label: "Curacao",
        flag: "https://flagcdn.com/w320/cw.png",
      },
      {
        value: "Dominica",
        label: "Dominica",
        flag: "https://flagcdn.com/w320/dm.png",
      },
      {
        value: "Dominican Republic",
        label: "Dominican Republic",
        flag: "https://flagcdn.com/w320/do.png",
      },
      {
        value: "Ecuador",
        label: "Ecuador",
        flag: "https://flagcdn.com/w320/ec.png",
      },
      {
        value: "El Salvador",
        label: "El Salvador",
        flag: "https://flagcdn.com/w320/sv.png",
      },
      {
        value: "Grenada",
        label: "Grenada",
        flag: "https://flagcdn.com/w320/gd.png",
      },
      {
        value: "Guatemala",
        label: "Guatemala",
        flag: "https://flagcdn.com/w320/gt.png",
      },
      {
        value: "Guyana",
        label: "Guyana",
        flag: "https://flagcdn.com/w320/gy.png",
      },
      {
        value: "Haiti",
        label: "Haiti",
        flag: "https://flagcdn.com/w320/ht.png",
      },
      {
        value: "Honduras",
        label: "Honduras",
        flag: "https://flagcdn.com/w320/hn.png",
      },
      {
        value: "Jamaica",
        label: "Jamaica",
        flag: "https://flagcdn.com/w320/jm.png",
      },
      {
        value: "Mexico",
        label: "Mexico",
        flag: "https://flagcdn.com/w320/mx.png",
      },
      {
        value: "Nicaragua",
        label: "Nicaragua",
        flag: "https://flagcdn.com/w320/ni.png",
      },
      {
        value: "Panama",
        label: "Panama",
        flag: "https://flagcdn.com/w320/pa.png",
      },
      {
        value: "Paraguay",
        label: "Paraguay",
        flag: "https://flagcdn.com/w320/py.png",
      },
      {
        value: "Peru",
        label: "Peru",
        flag: "https://flagcdn.com/w320/pe.png",
      },
      {
        value: "Puerto Rico",
        label: "Puerto Rico",
        flag: "https://flagcdn.com/w320/pr.png",
      },
      {
        value: "Saint Kitts and Nevis",
        label: "Saint Kitts and Nevis",
        flag: "https://flagcdn.com/w320/kn.png",
      },
      {
        value: "Saint Lucia",
        label: "Saint Lucia",
        flag: "https://flagcdn.com/w320/lc.png",
      },
      {
        value: "Saint Martin (French part)",
        label: "Saint Martin (French part)",
        flag: "https://flagcdn.com/w320/sx.png",
      },
      {
        value: "Saint Vincent and the Grenadines",
        label: "Saint Vincent and the Grenadines",
        flag: "https://flagcdn.com/w320/vc.png",
      },
      {
        value: "Sint Maarten (Dutch part)",
        label: "Sint Maarten (Dutch part)",
        flag: "https://flagcdn.com/w320/sx.png",
      },
      {
        value: "Suriname",
        label: "Suriname",
        flag: "https://flagcdn.com/w320/sr.png",
      },
      {
        value: "Trinidad and Tobago",
        label: "Trinidad and Tobago",
        flag: "https://flagcdn.com/w320/tt.png",
      },
      {
        value: "Turks and Caicos Islands",
        label: "Turks and Caicos Islands",
        flag: "https://flagcdn.com/w320/tc.png",
      },
      {
        value: "United States",
        label: "United States",
        flag: "https://flagcdn.com/w320/us.png",
      },
      {
        value: "United States Virgin Islands",
        label: "United States Virgin Islands",
        flag: "https://flagcdn.com/w320/vi.png",
      },
      {
        value: "Uruguay",
        label: "Uruguay",
        flag: "https://flagcdn.com/w320/uy.png",
      },
      {
        value: "Venezuela",
        label: "Venezuela",
        flag: "https://flagcdn.com/w320/ve.png",
      },
    ],
    Continental: [
      {
        value: "American Samoa",
        label: "American Samoa",
        flag: "https://flagcdn.com/w320/as.png",
      },
      {
        value: "Australia",
        label: "Australia",
        flag: "https://flagcdn.com/w320/au.png",
      },
      {
        value: "Christmas Island",
        label: "Christmas Island",
        flag: "https://flagcdn.com/w320/cx.png",
      },
      {
        value: "Cook Islands",
        label: "Cook Islands",
        flag: "https://flagcdn.com/w320/ck.png",
      },
      {
        value: "Fiji",
        label: "Fiji",
        flag: "https://flagcdn.com/w320/fj.png",
      },
      {
        value: "French Polynesia",
        label: "French Polynesia",
        flag: "https://flagcdn.com/w320/pf.png",
      },
      {
        value: "Guam",
        label: "Guam",
        flag: "https://flagcdn.com/w320/gu.png",
      },
      {
        value: "Kiribati",
        label: "Kiribati",
        flag: "https://flagcdn.com/w320/ki.png",
      },
      {
        value: "Marshall Islands",
        label: "Marshall Islands",
        flag: "https://flagcdn.com/w320/mh.png",
      },
      {
        value: "Micronesia",
        label: "Micronesia",
        flag: "https://flagcdn.com/w320/fm.png",
      },
      {
        value: "Nauru",
        label: "Nauru",
        flag: "https://flagcdn.com/w320/nr.png",
      },
      {
        value: "New Caledonia",
        label: "New Caledonia",
        flag: "https://flagcdn.com/w320/nc.png",
      },
      {
        value: "New Zealand",
        label: "New Zealand",
        flag: "https://flagcdn.com/w320/nz.png",
      },
      {
        value: "Niue",
        label: "Niue",
        flag: "https://flagcdn.com/w320/nu.png",
      },
      {
        value: "Norfolk Island",
        label: "Norfolk Island",
        flag: "https://flagcdn.com/w320/nf.png",
      },
      {
        value: "Northern Mariana Islands",
        label: "Northern Mariana Islands",
        flag: "https://flagcdn.com/w320/mp.png",
      },
      {
        value: "Palau",
        label: "Palau",
        flag: "https://flagcdn.com/w320/pw.png",
      },
      {
        value: "Papua New Guinea",
        label: "Papua New Guinea",
        flag: "https://flagcdn.com/w320/pg.png",
      },
      {
        value: "Pitcairn Islands",
        label: "Pitcairn Islands",
        flag: "https://flagcdn.com/w320/pn.png",
      },
      {
        value: "Samoa",
        label: "Samoa",
        flag: "https://flagcdn.com/w320/ws.png",
      },
      {
        value: "Solomon Islands",
        label: "Solomon Islands",
        flag: "https://flagcdn.com/w320/sb.png",
      },
      {
        value: "Tonga",
        label: "Tonga",
        flag: "https://flagcdn.com/w320/to.png",
      },
      {
        value: "Tuvalu",
        label: "Tuvalu",
        flag: "https://flagcdn.com/w320/tv.png",
      },
      {
        value: "Vanuatu",
        label: "Vanuatu",
        flag: "https://flagcdn.com/w320/vu.png",
      },
      {
        value: "Wallis and Futuna",
        label: "Wallis and Futuna",
        flag: "https://flagcdn.com/w320/wf.png",
      },
    ],
  };


 
  

  const {id}  = useParams()
  const location = useLocation();
  const [sortedData,setSortedData] = useState('')
 // 1. Fetch Admin Ships
useEffect(() => {
  async function fetchdata() {
    try {
      const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewLogistics`, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res1.data.status === 200) {
        console.log(res1)
        setallShips(res1.data.data.reverse())
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchdata();
}, [config.base_url, count]);



// 3. Merge and sort once both fetches complete
useEffect(() => {
  const filteredAllShipsReg = allShipsReg
    .filter((ship) => ship.is_allow)
    .map((ship) => ({ ...ship, isFromReg: true }));

  const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false }));

  const mergedSorted = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  setSortedData(mergedSorted);
  setFilteredShips(mergedSorted);
}, [allShips, allShipsReg]);

 // Add an identifier to distinguish Admin Ships and Customer Ships
 const filteredAllShipsReg = allShipsReg
 .filter((ship) => ship.is_allow)
 .map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale
 
 const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false })); // Mark as Admin Ship
 
 
 

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRegionValue, setSelectedRegionValue] = useState('');
const searchParams = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(searchParams.get("page")) || 1;

  
  const [itemsPerPage, setItemsPerPage] = useState(8);  // Number of cards per page
         useEffect(() => {
         const updateItemsPerPage = () => {
           if (window.innerWidth >= 1850) {
             setItemsPerPage(10); // 2xl screens
           } else {
             setItemsPerPage(8); // Default for other sizes
           }
         };
       
         updateItemsPerPage(); // Call on mount
       
         window.addEventListener("resize", updateItemsPerPage);
         return () => window.removeEventListener("resize", updateItemsPerPage);
       }, []);
  
   const activeShips = filteredShips.filter(ship => ship.is_status === true);
   const totalPages = itemsPerPage > 0 ? Math.ceil(activeShips.length / itemsPerPage) : 1;
   
        useEffect(() => {
                if (pageFromUrl >= 1 && pageFromUrl <= totalPages) {
                  setCurrentPage(pageFromUrl);
                  setRefPage(pageFromUrl);
                }
              }, [pageFromUrl, totalPages]);
       
              const totalCombinedPages = Math.ceil(sortedData.length / itemsPerPage);
   


         // Handle page change
         const handlePageChange = (page) => {
           if (page >= 1 && page <= totalPages) {
             setRefPage(page); // Update reference page
             setCurrentPage(page); // Update state (reactive)
             navigate(`/adminLogistic?page=${page}`); // Update URL
           }
       
           if (page >= 1 && page <= totalCombinedPages) {
           localStorage.setItem("currentPage", page); // Save page
           window.scrollTo({ top: 50, behavior: 'smooth' }); // Smooth scroll to top
       
           setTimeout(() => {
           }, 300); // Adjust delay as needed
         }
         };
       
         useEffect(() => {
         const savedPage = parseInt(localStorage.getItem("currentPage"));
         if (savedPage && savedPage >= 1 && savedPage <= totalCombinedPages) {
           setCurrentPage(savedPage);
         } else {
           setCurrentPage(1); // Default to 1 if nothing saved
         }
       }, []);
       
       useEffect(() => {
         const savedPage = parseInt(localStorage.getItem("currentPage"));
         if (savedPage && savedPage >= 1 && savedPage <= totalCombinedPages) {
           setCurrentPage(savedPage);
         } else {
           setCurrentPage(1); // Default to 1 if nothing saved
         }
       }, []);


  const handleSearch = (selectedCountry) => {
  if (!selectedCountry) {
    setFilteredShips(sortedData);
    return;
  }

  const results = sortedData.filter(
    (ship) =>
      ship.flag &&
      selectedCountry &&
      ship.flag.toLowerCase() === selectedCountry.toLowerCase()
  );

  setFilteredShips(results);
};

  const handleRegionClick = (region) => {
    setSelectedRegion(region);
    setSelectedCountry(null);
    
  };

  const token = localStorage.getItem('token')
  useEffect(() => {
      if (!token) {
        navigate('/login'); // login page
      }
    }, [token, navigate]);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption?.value || null);

  
  };

  const handleBack = () => {
    setSelectedCountry(null);
    setSelectedRegion(null);
   
    setCurrentPage(1);
    setFilteredShips(sortedData);
    setSelectedRegionValue('');
  };

  

  const [searchValue, setSearchValue] = useState("");

// Handles search logic
const handleSearchCapacity = () => {
  if (searchValue.trim() !== "") {
    // your search function here
    console.log("Searching for:", searchValue);
    // e.g., searchByCapacity(searchValue);
  }
};

// Handles Enter key
const handleKeyDown = (e) => {
  if (e.key === "Enter") {
    handleSearch();
  }
};

 const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;
const displayedShips = filteredShips
  .filter(ship => ship.is_status === true)
  .slice(startIndex, endIndex);


  const [isScrolled, setIsScrolled] = useState(false);
  // Track scrolling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [allImages,setallImages] = useState([])
  
  useEffect(() => {
    async function fetchdata() {
      
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :",res3);
          setallImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url,count]);

   const [Amenities,setAmenities] = useState([])
  
    useEffect(() => {
      async function fetchdata() {
        try {
          const res = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (res.data.status === 200) {
            console.log('Amenity',res);
            setAmenities(res.data.data);
          } else {
            console.log(res);
          }
        } catch (err) {
          console.log("error2", err);
        }
      }
      fetchdata();
    }, [config.base_url]);

  const [allImagesReg,setAllImagesReg] = useState([])
      
        useEffect(() => {
          async function fetchdata() {
            try {
              const res3 = await axios.get(
                `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  }
                }
              );
              if (res3.data.status === 200) {
                console.log("Images :",res3);
                setAllImagesReg(res3.data.data);
              } else {
                console.log("error");
              }
            } catch (error) {
              console.log(error);
            }
          }
          fetchdata();
        }, [config.base_url,count]);


        const handleNavigateToSingleShip = (ship) => {
          const route = ship.is_allow ? ` /singleShipCharter/${ship.id}` : `/singleShip/${ship.id}`;
          
          navigate(route, {
            state: {
              from: location.pathname,
              page: currentPage, // Store current pagination page
            },
          });
        };

       const rotations = ['rotate-[]', 'rotate-[4deg]', 'rotate-[-6deg]', 'rotate-[5deg]', 'rotate-[-2deg]'];
const pinPositions = [ 'top-4 left-1/2 -translate-x-1/2'];
const positions = [
  { top: "30%", left: "35%" },
  { top: "20%", left: "50%" },
  { top: "40%", left: "60%" },
  { top: "50%", left: "30%" },
  { top: "25%", left: "45%" },
];


  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log("User:", res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [token]);

const currentShip = displayedShips[currentPage];

 const allCountries = Object.entries(regions).flatMap(([region, countries]) =>
    countries.map((country) => ({
      ...country,
      region,
    }))
  );


const [dropdownOpen, setDropdownOpen] = useState(false);
const [activeRegion, setActiveRegion] = useState(null);  // clicked region
  const [hoveredRegion, setHoveredRegion] = useState(null); // hovered region
const dropdownRef = useRef(null);

  // Close dropdown on outside click
 useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setActiveRegion(null);
        setHoveredRegion(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


   const [selectedShip, setSelectedShip] = useState(null);
  const [CompanyAddress,setCompanyAddress] = useState('');
      const [Company,setCompany] = useState('');
      const [Lychan,setLychan] = useState('');
      const [TypeOfCargo,setTypeOfCargo] = useState('')
      const [Tonnage,setTonnage] = useState('')
      const [LoadingPort,setLoadingPort] = useState('')
      const [DischargePort,setDischargePort] = useState('')
      const [ChartererAcc,setChartererAcc] = useState('')
      const [Commission,setCommission] = useState('')
        const [Name, setName] = useState("");
        const [Email, setEmail] = useState("");
        const [Mobile, setMobile] = useState("");
        const [showPaymentModal, setShowPaymentModal] = useState(false); // Payment plan modal
          const [isOpenModal, setIsOpenModal] = useState(false); // for dropdown
          const [showModal, setShowModal] = useState(false); // for enquiry modal
          const [CreatedAt, setCreatedAt] = useState("");


      const handleOwnerInfo = async (ship) => {
    setSelectedShip(ship); // 👈 save the ship for checkout later
    if (user.is_superuser) {
      setEmail(ship.email || "N/A");
      setMobile(ship.phone || "N/A");
      setCreatedAt(ship.created_at);
      setChartererAcc(ship.charterer_account || "N/A");
      setTypeOfCargo(ship.type_of_cargo || "N/A");
      setCompany(ship.company || "N/A");
      setCompanyAddress(ship.company_address || "N/A");
      setName(ship.name || "N/A");
      setEmail(ship.email || "N/A");
      setTonnage(ship.tonnage || "N/A");
      setCommission(ship.commission || "N/A");
      setLoadingPort(ship.loading_port || "N/A");
      setLychan(ship.lychan || "N/A");
      setDischargePort(ship.discharge_port || "N/A");
      // setShipCode(ship.ship_code || "N/A");
      // setShipId(ship.id || "N/A");


      setShowModal(true);
      return;
    }
  };

  const [expandedShipId, setExpandedShipId] = useState(null);
          
          useEffect(() => {
      const params = new URLSearchParams(location.search);
      const shipIdFromUrl = params.get("shipId");
  
      // guard: need an id in URL, ships loaded, and we haven't already auto-expanded
      if (!shipIdFromUrl || displayedShips.length === 0 || expandedShipId) return;
  
      const shipData = displayedShips.find(
        (s) => String(s.id) === String(shipIdFromUrl)
      );
      if (shipData) {
        // expand the card
        setExpandedShipId(shipData.id);
  
        // remove the query param from the address bar so it won't keep forcing expansion
        // use replace:true so we don't add another history entry
        const params = new URLSearchParams(location.search);
      params.delete("shipId"); // remove only shipId
      navigate(`${location.pathname}?${params.toString()}`, { replace: true });

      }
    }, [location.search, displayedShips, expandedShipId, navigate, location.pathname]);
  
          
            
          
           const toggleExpand = (shipId) => {
  setExpandedShipId((prev) => (prev === shipId ? null : shipId));
};

        
              const handleShare = (shipId,) => {
  const shareUrl = `http://localhost:3000/open-cargo?shipId=${shipId}`;
  const message = `Check out this ship available for charter:\n${shareUrl}`;
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, "_blank");
};

const [loadingShipId, setLoadingShipId] = useState(null);

const handleSendCargoToZoho = async (cargoId) => { 
  setLoadingShipId(cargoId);
  try {
    const res = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/send-cargo-to-zoho/${cargoId}/`,
      {},
      { headers: { Authorization: `Token ${token}` } }
    );

    if (res.status === 200) {
      toast.success("Cargo details sent to Zoho successfully!");
      setLoadingShipId(null);
    } else {
      toast.error(`Failed: ${res.data?.error || "Unknown error"}`);
    }
  } catch (err) {
    console.error("Zoho send error:", err);
    // const msg =
    //   err.response?.data?.details ||
    //   err.response?.data?.error ||
    //   err.message ||
    //   "Error sending cargo data to Zoho";
    // toast.error(msg);
  } finally {
    setLoadingShipId(null);
  }
};





      
  return (
    <div>
      <div className="">
        <NewAdminNav />

        <section className="bg-[#9ccee2]">
          
          {/* <h1 className="text-gray-50 text-2xl text-center font-bold py-5">Cargo Ready To Load</h1> */}
          <div className=" py-5  xs:px-2">
                      {/* main */}
                      <div className="  mt-3">
                        {/* left side */}
                        {selectedView === "ship" && (
                          <div className="">
                            <div className=" w-[100%]  px-5 xl:px-4  text-[#d1a460] text-xl m-auto">
                              <h1 className="font-semibold text-xl  hidden xm:block">
                                Looking For
                              </h1>
                              {/* select region */}
                              {/* Show Region Select only when no region is selected */}
                              <div className="w-full xm:mt-3 mb-5  xm:mb-8">
                                <div className="flex gap-5 justify-center flex-wrap">
                                  <h1 className="font-semibold text-xl mt-2 xm:hidden">
                                    Looking For
                                  </h1>
                                  {/* Type of ship */}
                                  <div className="w-[200px] xm:w-full">
                                    <select
                                      className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                                      name="vesselType"
                                      id="VesselType"
                                    >
                                      <option hidden selected value="">
                                        - Type of Ships-
                                      </option>
                                      <option
                                        disabled
                                        className="text-gray-500 font-semibold"
                                        value=""
                                      >
                                        Catagories
                                      </option>
                                      <option value="Barge" className="text-gray-500">
                                        Barge
                                      </option>
                                      <option value="Bulk" className="text-gray-500">
                                        Bulk
                                      </option>
                                      <option value="Cargo" className="text-gray-500">
                                        Cargo
                                      </option>
                                      <option value="Container" className="text-gray-500">
                                        Container
                                      </option>
                                      <option value="Fishing" className="text-gray-500">
                                        Fishing
                                      </option>
                                      <option
                                        value="Multipurpose"
                                        className="text-gray-500"
                                      >
                                        Multipurpose
                                      </option>
                                      <option
                                        value="Passenger/Ferry"
                                        className="text-gray-500"
                                      >
                                        Passenger/Ferry
                                      </option>
                                      <option value="Reefer" className="text-gray-500">
                                        Reefer
                                      </option>
                                      <option value="RoRo" className="text-gray-500">
                                        RoRo
                                      </option>
                                      <option value="Tanker" className="text-gray-500">
                                        Tanker
                                      </option>
                                      <option value="Dredger" className="text-gray-500">
                                        Dredger
                                      </option>
                                      <option
                                        value="Floating Crane"
                                        className="text-gray-500"
                                      >
                                        Floating Crane
                                      </option>
                                      <option
                                        value="Floating Dock"
                                        className="text-gray-500"
                                      >
                                        Floating Dock
                                      </option>
                                      <option
                                        value="Landing Craft"
                                        className="text-gray-500"
                                      >
                                        Landing Craft
                                      </option>
                                      <option value="Yacht" className="text-gray-500">
                                        Yacht
                                      </option>
                                      <option value="Tug Boat" className="text-gray-500">
                                        Tug Boat
                                      </option>
                                      <option
                                        value="Supply Boat"
                                        className="text-gray-500"
                                      >
                                        Supply Boat
                                      </option>
                                      <option value="crew Boat" className="text-gray-500">
                                        Crew Boat
                                      </option>
                                      <option value="Other " className="text-gray-500">
                                        Other
                                      </option>
                                    </select>
                                  </div>
          
                                  {/* Open Area */}
                                  <div
                                    ref={dropdownRef}
                                    className="relative w-[200px] xm:w-full"
                                  >
                                    {/* Toggle */}
                                    <div
                                      className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                                      onClick={() => setDropdownOpen((prev) => !prev)}
                                    >
                                      <div className="flex justify-between items-center">
                                        <p>{selectedCountry || "-Open Area-"}</p>
                                        <i className="fa-solid text-sm fa-chevron-down"></i>
                                      </div>
                                    </div>
          
                                    {/* Dropdown */}
                                    {dropdownOpen && (
                                      <div className="absolute top-12 mt-1 left-0 w-full  shadow-md bg-gray-200   p-2 border rounded z-50 max-h-[300px] overflow-y-auto">
                                        {allCountries.map((country) => (
                                          <div
                                            key={country.value}
                                            className="flex items-center gap-2  py-3 hover:bg-gray-300 cursor-pointer"
                                            onClick={() => {
                                              setSelectedCountry(`${country.label}`);
                                              setDropdownOpen(false);
                                            }}
                                          >
                                            <img
                                              src={country.flag}
                                              alt=""
                                              className="w-5 h-5"
                                            />
                                            {country.label}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </div>
          
                                  {/* TC/VC */}
                                  <div className="w-[200px]  xm:w-full">
                                    <select
                                      className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                                      name="Tc/VC"
                                      id="Tc/VC"
                                    >
                                      <option disabled selected value="">
                                        - TC/VC-
                                      </option>
                                      <option value="Barge" className="text-gray-500">
                                        Time Charter
                                      </option>
                                      <option value="Bulk" className="text-gray-500">
                                        Voyage Charter
                                      </option>
                                    </select>
                                  </div>
          
                                  {/* Capacity */}
                                  <div className="w-[200px] mb-10 xm:w-full">
                                    <select
                                      className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                                      name="Capacity"
                                      id="Capacity"
                                    >
                                      <option hidden selected value="">
                                        - Capacity-
                                      </option>
                                      <option
                                        disabled
                                        className="text-gray-500 font-semibold"
                                        value=""
                                      >
                                        Catagories
                                      </option>
                                      <option value="Barge" className="text-gray-500">
                                        1000 - 5000
                                      </option>
                                      <option value="Bulk" className="text-gray-500">
                                        5000 - 10000
                                      </option>
                                      <option value="Cargo" className="text-gray-500">
                                        10000 - 15000
                                      </option>
                                      <option value="Container" className="text-gray-500">
                                        15000 - 25000
                                      </option>
                                      <option value="Fishing" className="text-gray-500">
                                        25000 - 50000
                                      </option>
                                      <option
                                        value="Multipurpose"
                                        className="text-gray-500"
                                      >
                                        50000 - more
                                      </option>
                                    </select>
                                  </div>
          
                                  <div className="flex gap-3 items-center -mt-10">
                                    <button className="bg-gray-50  px-3 py-[10px] rounded-xl w-full ">
                                      Clear
                                    </button>
                                    <button className="bg-[#d1a460] text-gray-50 hover:bg-[#c6a067] px-3 py-[10px] rounded-xl w-full ">
                                      Search
                                    </button>
                                  </div>
                                </div>
          
                                {/* <div className="">
                                    <div className="w-[300px]  xl:w-[100%] flex-shrink-0">
          <Select
            className=" w-[90%] m-auto"
            options={regions[selectedRegion]}
            placeholder="Select a country"
            value={
              selectedCountry
                ? regions[selectedRegion]?.find((c) => c.label === selectedCountry)
                : null
            }
            onChange={(selectedCountry) => {
              setSelectedCountry(selectedCountry.label);
              handleSearch(selectedCountry.label);
              handleCountryChange(selectedCountry);
            }}
            isSearchable
            getOptionLabel={(e) => (
              <div className="flex items-center gap-2">
                <img src={e.flag} alt="" className="w-5 h-5" />
                {e.label}
              </div>
            )}
          />
          
          
                                    
          
                                     {selectedCountry &&(
                                      <button
                                        className="capsule-3d border border-white  py-3 w-[90%] m-auto mt-10"
                                        onClick={handleBack}
                                      >
                                        <i className="fa-solid fa-arrow-left fa-beat me-2"></i>{" "}
                                        Back to Regions
                                      </button>
                                     ) }
                                    </div>
          
                                    <div>
                                      
                                      
                                    </div>
                                  </div> */}
                              </div>
          
                              <>
                                <div className=" w-[100%]  m-auto">
                                  {/* Display All Ships */}
                                  <div className="w-[100%] m-auto">
                                     <div className="mb-5 px-10 flex gap-3 items-center">
                            <button className="bg-[#d1a460] p-2 rounded-lg text-gray-50 shadow">View List</button>
                            <button onClick={()=>{navigate('/map/open-cargo')}} className="bg-gray-50 p-2 rounded-lg text-[#d1a460] shadow">View Cargos in Map</button>
                            </div>
                                    <div className="flex flex-wrap justify-center gap-10 mb-5">
                                      
                                      {displayedShips
                                        
                                        .map((ship, index) => (
                                          <div
                                          id={`ship-${ship.id}`}
                                          onClick={() => toggleExpand(ship.id)}
                                    key={index}
                                    className={`relative border-2 border-[#d1a460] rounded-lg overflow-hidden bg-white shadow-xl py-4 px-3 transition-all duration-500 flex flex-col
  ${expandedShipId === ship.id ? "w-[500px] h-[350px] xm:h-full z-0 lg:w-[600px]" : "w-[330px] lg:w-[600px]  mx:h-full hover:scale-105 cursor-pointer  h-[350px] xs:w-full"}`}
                                  >
                                    {/* Main Info + Expanded Details */}
                                    <div
                                      className={`transition-all duration-500 ${
                                        expandedShipId === ship.id ? "flex flex-row gap-4" : "flex flex-col"
                                      } flex-1`}  
                                    >
                                      {/* Main Card Info */}
                                      <div className="flex-1">
                                        {expandedShipId !== ship.id && (
                                          <>
                                            <i
                                                                      className={`bx  bxs-pin-alt text-2xl -mt-3  text-red-600  absolute ${
                                                                        pinPositions[index % pinPositions.length]
                                                                      }`}
                                                                    ></i>
                                            <div className="py-1 border-b text-start text-lg border-black font-bold text-gray-800">
                                              <p className="bg-[#d1a460] rounded p-2 text-center">
                                                {ship.type_of_cargo}
                                              </p>
                                            </div>
                                            <p className="text-sm py-2 border-b text-start border-black font-bold text-gray-800">
                                              Loading Port : {ship.loading_port || "N/A"}
                                            </p>
                                            <p className="text-sm py-2 border-b text-start border-black font-bold text-gray-800">
                                              Discharge Port : {ship.discharge_port || "N/A"}
                                            </p>
                                            <p className="font-bold py-2 text-sm text-gray-800 text-start">
                                              Tonnage : {ship.tonnage}
                                            </p>
                                            <p className="font-bold text-start mt-1 text-sm text-gray-800">
                                              Lychan : {ship.lychan}
                                            </p>
                                          </>
                                        )}
                                      </div>
                                   
                                      {expandedShipId === ship.id && (
                                                <div className="w-full flex flex-col">
                                                   <button
                                  onClick={() => toggleExpand(ship.id)}
                                  className="absolute -left-3 -top-3  text-red-500 px-4 py-2   transition"
                                >
                                <h1 onClick={() => toggleExpand(ship.id)} className="font-semibold">X</h1>
                                </button>
                                                  {/* Header */}
                                                  <div className="bg-[#d1a460] p-2 mb-2 flex justify-between items-center rounded">
                                                    <p className="text-center font-bold text-sm text-gray-800">
                                                      {ship.type_of_cargo}, {ship.tonnage}, Open {ship.loading_port}
                                                    </p>
                                                    {/* <p className="text-center font-bold text-sm text-gray-800">
                                                      {ship.id}
                                                    </p> */}
                                                  </div>
                                  
                                                  <div className="flex xm:flex-wrap gap-2">
                                                    {/* Cargo Info */}
                                                    <div className="bg-[#fdf8f3] h-[200px] xm:max-h-screen overflow-y-scroll border border-[#d1a460] rounded-xl p-2 mb-2 w-full">
                                                      <ul className="list-disc list-inside">
                                                        <li className="text-sm text-gray-800">
                                                          <span className="font-bold">Loading Port:</span>{" "}
                                                          {ship.loading_port || "N/A"}
                                                        </li>
                                                        <li className="text-sm text-gray-800">
                                                          <span className="font-bold">Discharge Port:</span>{" "}
                                                          {ship.discharge_port || "N/A"}
                                                        </li>
                                                        <li className="text-sm text-gray-800">
                                                          <span className="font-bold">Lychan:</span>{" "}
                                                          {ship.lychan || "N/A"}
                                                        </li>
                                                        <li className="text-sm text-gray-800">
                                                          <span className="font-bold">Tonnage:</span>{" "}
                                                          {ship.tonnage || "N/A"}
                                                        </li>
                                                       
                                                        <li className="text-sm text-gray-800">
                                                          <span className="font-bold">Commission:</span>{" "}
                                                          {ship.commission || "N/A"}
                                                        </li>
                                                        {ship.brief_description?.split("\n").map((line, idx) => (
                        <li
                          key={idx}
                          className="text-sm text-gray-800 leading-relaxed"
                        >
                          {line}
                        </li>
                      ))}
                       <li className="text-sm text-gray-800">
                                                          <span className="font-bold">Charterer Account:</span>{" "}
                                                          {ship.charterer_account || "N/A"}
                                                        </li>
                                                      </ul>
                                                    </div>
                                  
                                                    {/* Owner Info */}
                                                    <div className="border h-[200px] xm:max-h-screen overflow-y-scroll border-[#d1a460] rounded-xl p-2 w-full">
                                                      <h3 className="bg-[#d1a460] text-[#123d5f] px-2 py-1 rounded-t-xl font-bold text-sm">
                                                        Owner Information
                                                      </h3>
                                                      <div className="p-2 space-y-1 text-sm text-gray-700">
                                                        <p><span className="font-semibold">Name:</span> {ship.name || "N/A"}</p>
                                                        <p><span className="font-semibold">Company:</span> {ship.company || "N/A"}</p>
                                                        <p><span className="font-semibold">Email:</span> {ship.email || "N/A"}</p>
                                                        <p><span className="font-semibold">Mobile:</span> {ship.phone || "N/A"}</p>
                                                        <p>
                                                          <span className="font-semibold">Created At:</span>{" "}
                                                          {ship.created_at
                                                            ? formatDistanceToNow(new Date(ship.created_at), { addSuffix: true })
                                                            : "N/A"}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                    </div>
                                  
                                    {/* Toggle + Share Buttons */}
                                     <div className="mt-auto">   {/* 🔥 always sticks to bottom */}
                              {expandedShipId === ship.id ? (
                                <div className="flex justify-between gap-2 mt-3">
                                  <button
                                          className="flex items-center justify-center gap-2 px-2 py-1 w-50 bg-[#123d5f] rounded-lg text-white disabled:opacity-70"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleSendCargoToZoho(ship.id);
                                          }}
                                          disabled={loadingShipId === ship.id}
                                        >
                                          {loadingShipId === ship.id ? (
                                            <>
                                              <svg
                                                className="animate-spin h-4 w-4 text-white"
                                                xmlns="http://www.w3.org/2000/svg"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                              >
                                                <circle
                                                  className="opacity-25"
                                                  cx="12"
                                                  cy="12"
                                                  r="10"
                                                  stroke="currentColor"
                                                  strokeWidth="4"
                                                ></circle>
                                                <path
                                                  className="opacity-75"
                                                  fill="currentColor"
                                                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                                                ></path>
                                              </svg>
                                              <span>Sending...</span>
                                            </>
                                          ) : (
                                            "Promotion"
                                          )}
                                        </button>

                                  <button
                                    onClick={(e) => {
                              e.stopPropagation(); // ⛔ prevent parent div click
                              handleShare(ship.id, currentPage)
                            }}
                                    className="flex-1 bg-green-500 text-white px-2 py-1 rounded-lg flex items-center justify-center gap-2 hover:bg-green-600 transition"
                                  >
                                    <i className="fa-brands fa-whatsapp text-xl"></i>
                                    Share
                                  </button>
                                </div>
                              ) : (
                                <button
                                 
                                  className="px-2 py-2 mt-3 bg-[#123d5f] rounded-lg text-white w-full"
                                >
                                  More Information
                                </button>
                              )}
                            </div>
                                  </div>
                                  
                                        ))}
                                    
                                    </div>
                                  
                                    {/* Pagination */}
                                     {displayedShips.length > 0 && (
                              <div className="flex justify-center m-auto mt-2 items-center gap-2 ">
                                <button
                                  className={`px-4 py-2 bg-[#123d5f] text-white rounded-sm ${
                                    currentPage === 1
                                      ? "opacity-50 cursor-not-allowed"
                                      : "hover:bg-[#172f41ed]"
                                  }`}
                                  onClick={() =>
                                    handlePageChange(currentPage - 1)
                                  }
                                  disabled={currentPage === 1}
                                >
                                  <i className="fa-solid fa-chevron-left"></i>
                                </button>
                                <span className="px-4 py-2 bg-[#d1a460] text-white rounded-sm">
                                  {currentPage}
                                </span>
                                <button
                                  className={`px-4 py-2 bg-[#0d2c45] text-white rounded-sm ${
                                    currentPage === totalPages
                                      ? "opacity-50 cursor-not-allowed"
                                      : "hover:bg-[#172f41ed]"
                                  }`}
                                  onClick={() =>
                                    handlePageChange(currentPage + 1)
                                  }
                                  disabled={currentPage === totalPages}
                                >
                                  <i className="fa-solid fa-chevron-right"></i>
                                </button>
                              </div>
                            )}
                                  </div>
                                </div>
                              </>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
        </section>

        {/* Go to Top Button */}
        {isScrolled && (
          <div
            className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
          >
            <div
              className="back-to-top px-4 hover:bg-[#615d91]"
              onClick={scrollToTop}
            >
              <i className="fa-solid fa-arrow-up text-2xl"></i>
            </div>
          </div>
        )}

        <NewFooter />
      </div>
    </div>
  );
}
